import { z } from 'zod';
import { defineEndpoint } from '../define';
import { RequiredArtifactSchema } from './shapes';

export const listRequiredArtifacts = defineEndpoint({
  method: 'GET',
  path: '/v1/release-products/:productId/required-artifacts',
  params: z.object({ productId: z.string().uuid() }),
  query: z.object({ environment: z.enum(['dev', 'sit', 'uat', 'prd']) }),
  body: z.undefined(),
  response: z.object({ data: z.array(RequiredArtifactSchema) }),
});
